import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../libs/core/axios-base-query";


export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: axiosBaseQuery({ baseUrl: "https://lbcapi.enkubeauty.com/api" }),
  // baseQuery: axiosBaseQuery({ baseUrl: "http://192.168.247.115:8001/api" }),
  tagTypes: [
    "User",
    "Project",
    "UnitTypes",
    "Blogs",
    "Teams",
    "Units",
    "Subscribers",
    "ScheduledVisit",
    "Testimonials",
    "Partners",
    "BankAccounts",
    "dashboardSummary",
    "Messages",
    "Newsletter",
    "ProjectDetail"
  ],
  endpoints: () => ({}),
});
